import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Box, Button, Container, Group, Paper, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const ErrorScreen = ({
  title,
  message,
  status,
  onRetry,
  retryLabel,
}) => {
  const { t } = useTranslation();

  return (
    <Box mih="60vh" py={40}>
      <Container size="sm">
        <Paper withBorder radius="lg" p="xl">
          <Stack gap="md" align="center">
            <ThemeIcon size={56} radius="xl" color="red" variant="light">
              <AlertTriangle size={28} />
            </ThemeIcon>

            {status && (
              <Text size="sm" c="dimmed" fw={600}>
                HTTP {status}
              </Text>
            )}

            <Title order={2} ta="center">
              {title || t('Something went wrong')}
            </Title>

            <Text ta="center" c="dimmed">
              {message || t('The data could not be loaded. Please try again.')}
            </Text>

            <Group justify="center">
              <Button
                leftSection={<RefreshCw size={16} />}
                onClick={onRetry || (() => window.location.reload())}
              >
                {retryLabel || t('Try again')}
              </Button>
            </Group>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default ErrorScreen;
